/* src/app/app.component.scss */
:root {
  --color1: #2172cd;
  --color2: #2e3d4c;
  --color3: #5bc7aa;
  --color4: #8f76e5;
  --color5: #f5cf50;
  --color6: #18a957;
  --color7: #f48f33;
  --color8: #df1642;
  --color9: #37baf6;
  --color10: #667c95;
}
.progress-bar {
  position: absolute;
  top: -7px;
  left: 0;
  right: 0;
  z-index: 99998;
}
.progress-bar.navClose {
  left: 1;
}
.progress-bar.navOpen {
  left: 251px;
}
.progress-bar::ng-deep .dx-trackbar-range {
  height: 4px;
  border-radius: 0;
}
.progress-bar::ng-deep .dx-progressbar-status {
  display: none;
}
:host {
  height: 100%;
  display: block;
  width: 100%;
}
.chat-button {
  position: absolute;
  bottom: 50px;
  right: 50px;
  z-index: 333;
}
/*# sourceMappingURL=app.component-SLYFVM5T.css.map */
